import { useTranslation } from "react-i18next";
import { UserSettings } from "@/partner/features/userSettings";
import { Meta } from "@/shared/components";

export const UserSettingsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("userSettings.pageTitle")} pageType="Partner" />
      <UserSettings />
    </>
  );
};
